import { useState } from "react";
import { api } from "@/lib/api";
import { Sparkles, Search } from "lucide-react";

export default function AIOps() {
  const [q, setQ] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const ask = async () => {
    if (!q.trim()) return;
    setLoading(true);
    try { const r = await api.post("/ai/knowledge-search", { query: q }); setAnswer(r.data.answer); } finally { setLoading(false); }
  };
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">AI Operations Center</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Knowledge & Decision Support</h1>
        <p className="text-sm text-zinc-500 mt-1">Large-language-model assistance · AI as a service layer · models swappable</p>
      </div>

      <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-2">Knowledge Search</div>
        <div className="flex gap-2">
          <div className="flex-1 relative"><Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" /><input data-testid="ai-search-input" value={q} onChange={e=>setQ(e.target.value)} placeholder="Ask: How do I fail over our domain controller?" className="w-full bg-zinc-900 border border-zinc-800 rounded pl-9 pr-3 py-2 text-sm focus:outline-none focus:border-blue-500/60"/></div>
          <button onClick={ask} disabled={loading} data-testid="ai-search-btn" className="bg-blue-600 hover:bg-blue-700 text-white text-sm rounded px-4 py-2 inline-flex items-center gap-2"><Sparkles size={14}/>{loading?"Searching…":"Ask AI"}</button>
        </div>
        {answer && <pre className="text-xs whitespace-pre-wrap text-zinc-300 leading-relaxed mt-4 border border-zinc-900 rounded p-4 bg-zinc-900/30" data-testid="ai-answer">{answer}</pre>}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {[
          {t: "AI Incident Summaries", d: "Summarize any ticket conversation in 3 bullet points."},
          {t: "Root Cause Analysis", d: "Cross-reference asset history & recurring patterns to surface root cause."},
          {t: "Compliance Recommendations", d: "Prioritized actions to lift framework scores."},
          {t: "Security Recommendations", d: "Top hardening actions for the next 30 days."},
          {t: "Executive Summaries", d: "CIO-grade monthly briefs from operational data."},
          {t: "QBR Generation", d: "Account-level Quarterly Business Reviews."},
        ].map(c => (
          <div key={c.t} className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
            <div className="flex items-center gap-2"><Sparkles size={14} className="text-blue-400" /><div className="font-display font-medium">{c.t}</div></div>
            <div className="text-sm text-zinc-400 mt-2">{c.d}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
